import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';
import lightBlue from '@material-ui/core/colors/lightBlue';

export const CardStatuses = Object.freeze({
  activationPending: { value: 'activationPending', color: lightBlue[500] },
  activated: { value: 'activated', color: green[500] },
  deactivated: { value: 'deactivated', color: red[300] }
});
